import orderBy from "lodash/orderBy";
import { useMemo } from "react";

export default function useSortBy(array = [], key, order = "desc") {
	return useMemo(() => orderBy(array, key, order), [array, key, order]);
}
